import { NegotiationRoundStatus, type NegotiationRoundDto, type SourcingEventDto } from "../../../autogen/bff-api";
import { isNegotiationWithoutNotice } from "../../../common/procurement/negotiationWithoutNotice";
import { isBidDeadlineStillOpen } from "../award/canSelectWinner";

export const roundStillOpen = (
  round: NegotiationRoundDto,
  rejectedOrganizationIds: string[],
  now: number = Date.now(),
): boolean =>
  round.status === NegotiationRoundStatus.Published &&
  Date.parse(round.deadline) > now &&
  round.invites.some((invite) => !rejectedOrganizationIds.includes(invite.organizationId));

export const publicBidDeadlineAhead = (event: SourcingEventDto, now: number = Date.now()): boolean =>
  event.eventContext.type === "Public" &&
  !isNegotiationWithoutNotice(event.eventContext.procedureType) &&
  isBidDeadlineStillOpen(event, now);
